/**
 * Validates a value for a given input key
 * @param key Input name
 * @param value Value of the input
 * @returns
 */
function reducer(key: string, value: any): string | undefined {
    switch (key) {
        case 'date_end':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'date_start':
            if (value && typeof value !== 'number') return `${key} must be a number`
            break
        case 'name':
            if (typeof value !== 'string') return `${key} must be a string`
            if (value.length < 3) return `At least three characters`
            break
        case 'file':
            if (!(value instanceof Array)) return `${key} must be an array of files`
            if (!value.length) return `Must select one file`
            break
        default:
            return undefined
    }
}

/**
 * For every input in a form, validate its value
 * @param values All inputs in the form
 * @returns An object with the error message for any failing input
 */
function validate(values: Record<string, any>) {
    return {
        ...Object.keys(values).reduce((obj, k: string) => {
            const out = obj
            const error = reducer(k, values[k])

            if (error) {
                out[k] = error
            }

            return obj
        }, {} as Record<string, string | undefined>),
    }
}

export default validate
